// eslint-disable-next-line simple-import-sort/imports
import "virtual:windi-components.css";
import "virtual:windi-utilities.css";
import "element-plus/dist/index.css";
import "./styles/main.less";
import { commonComponentsInstall } from "common";

import { createApp } from "vue";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { createPinia } from "pinia";
import router from "@/router";

import App from "./App.vue";

const app = createApp(App);
app.use(commonComponentsInstall);
app.use(createPinia());
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
app.mount("#app");
